import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "accessdate", label: "Огноо" },
  { prop: "provider_regnum", label: "Нийлүүлэгч" },
  { prop: "provider_branch", label: "Салбар" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "patch_id", label: "Patch" },
  { prop: "exception", label: "Exception" },
  { prop: "action", label: "Action" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Алдаатай нийлүүлсэн лог",
    endpoint: "/logs/exception",
    columns: columns,
    show: { provider: true, branch: true, patch: true }
  }))
}
}

})